import { render } from "./Portfolio.vue?vue&type=template&id=dfd9a4da"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__